import { render, staticRenderFns } from "./TriviaQuestion.vue?vue&type=template&id=77f56778&scoped=true"
import script from "./TriviaQuestion.vue?vue&type=script&lang=js"
export * from "./TriviaQuestion.vue?vue&type=script&lang=js"
import style0 from "./TriviaQuestion.vue?vue&type=style&index=0&id=77f56778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f56778",
  null
  
)

export default component.exports